<script>

    import {createEventDispatcher, onMount} from "svelte";

    import {
        getLocalPropertyId,
        getLocalPropertiesInfo
    } from "../utils/session";

    const dispatch = createEventDispatcher();

    let mainPropertyId;
    let propertyMap;

    onMount(() => {

        getPropertiesInfo();

    });

    let getPropertiesInfo = () => {

        mainPropertyId = getLocalPropertyId();

        propertyMap = getLocalPropertiesInfo();

    };

    let changeProperties = (kproperty) => {

        localStorage.setItem('kpropertyid', kproperty);

        getPropertiesInfo();

        dispatch('propertychange');
    }

    let showDropdown = false;

</script>

{#if propertyMap}

    <div id="property-selection" on:click={() => showDropdown = !showDropdown} class:multiple={Object.keys(propertyMap).length > 1}>

        {#each Object.entries(propertyMap) as [proKey, proItem], index(proKey)}

            {#if proKey === mainPropertyId}

                <span class="property-name">{proItem['name']}</span>
                <span class="property-address">{proItem['address']}</span>

            {:else}

                <img class="arrow-expand" src="images/arrow-change-down.svg" alt=""/>

                <div class="dropdown" class:expanded={showDropdown}>

                    <div class="property-item" data-lid="{proKey}" on:click={() => changeProperties(proKey)}>

                        <span class="property-name">{proItem['name']}</span>
                        <span class="property-address">{proItem['address']}</span>

                    </div>

                </div>

            {/if}

        {/each}

    </div>

{/if}
